import { render, staticRenderFns } from "./hotJobItem.vue?vue&type=template&id=f935a436&scoped=true"
import script from "./hotJobItem.vue?vue&type=script&lang=js"
export * from "./hotJobItem.vue?vue&type=script&lang=js"
import style0 from "./hotJobItem.vue?vue&type=style&index=0&id=f935a436&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f935a436",
  null
  
)

export default component.exports